<div class="w-100">
    <mwp-card-content-header [url]="apiUrl" />
    <div>
        <mwp-card-resource [resources]="resources" header="Benefit Documents" />
    </div>
</div>